import {SellerError} from './SellerError.js'

export class GetInstantOfferDetailsGenericSellerError extends SellerError {}
